module.exports = __webpack_public_path__ + "img/23.6a6be3a8.png";